function EktarApiBanner({ className, response, ...props }) {
    return <div id='ek_single_banner_api' className={className}>
        {response && <img src={response.imageUrlA} onClick={() => window.open(response.onClickUrlA, "_blank")} style={{cursor: 'pointer', width: '100%'}} alt=""></img>}
    </div>;
}

export default EktarApiBanner;